import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useRef } from "react";
import { UserMentionTooltip } from "~/components/Discussions/UserMention/components/UserMentionTooltip";
import { useHover } from "~/hooks/useHover";
export const UserMention = /*#__PURE__*/ memo((param)=>{
    let { userName, user } = param;
    const textRef = useRef(null);
    const { handleHover, isHovering, handleUnhover } = useHover();
    return /*#__PURE__*/ _jsxs("span", {
        onMouseEnter: handleHover,
        onMouseLeave: handleUnhover,
        children: [
            isHovering && user && /*#__PURE__*/ _jsx(UserMentionTooltip, {
                containerRef: textRef,
                user: user
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "cursor-pointer text-14 font-medium text-grey-11",
                ref: textRef,
                children: userName
            })
        ]
    });
});
UserMention.displayName = "UserMention";
